export const LOGIN_USER = "LOGIN_USER"
export const SOCIAL_LOGIN = "SOCIAL_LOGIN"
export const LOGOUT_USER = "LOGOUT_USER"
export const CHECK_USER="CHECK_USER";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_SUCCESSS = "LOGIN_SUCCESSS"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"
export const API_ERROR = "LOGIN_API_ERROR"

export const CHECK_USER_SUCCESS = "CHECK_USER_SUCCESS"
export const CHECK_USER_FAILED = "CHECK_USER_FAILED"

  